import { api, PROVIDER_API_SUB_URLS, V2 } from '@/api';
import { AxiosResponse } from 'axios';
import { Module } from 'vuex';
import { RootState } from '@/@types/member';
import { MemberProvidersResponseModel } from '@/@types/member';
import { ConstructAPIParams } from '@/helpers';
import { isNil } from 'lodash';

interface ProvidersState {
  providers: MemberProvidersResponseModel[];
}

const PROVIDERS_STATE: Module<ProvidersState, RootState> = {
  state: {
    providers: [],
  },
  actions: {
    // UC-REST-011 - Get Providers
    getProviders(context, params): Promise<AxiosResponse> {
      const apiParams = !isNil(params) ? ConstructAPIParams(params) : { limit: '1000' };
      // delete items not related to pagination, since use case doesn't use search or sorting
      // we don't want to implement the 'id' default search from ConstructAPIParams
      delete apiParams.sortBy;
      delete apiParams.search;
      return api
        .get(
          `${PROVIDER_API_SUB_URLS.members}/${
            context.getters.user.memberId
          }/providers${V2}`,
          {
            params: {
              ...apiParams,
            },
          },
        )
        .then((providers) => {
          context.commit('setProviders', providers.data ? providers.data : []);
          return providers;
        });
    },
    // UC-REST-067 - Add Provider
    addProvider(context, options): Promise<AxiosResponse> {
      return api
        .post(
          `${PROVIDER_API_SUB_URLS.members}/${
            context.getters.user.memberId
          }/providers${V2}`,
          options,
        )
        .then((provider) => {
          return provider.data;
        });
    },
    // UC-REST-013 - Update Provider
    updateProvider(context, options): Promise<AxiosResponse> {
      const PROVIDER_ID = options.id;
      delete options.id;
      return api
        .patch(
          `${PROVIDER_API_SUB_URLS.providers}${V2}/${PROVIDER_ID}`,
          options,
        )
        .then((provider) => {
          return provider.data;
        });
    },
    // UC-REST-073 - Delete Provider
    deleteProvider(context, providerId): Promise<AxiosResponse> {
      return api.put(
        `${PROVIDER_API_SUB_URLS.providers}${V2}/${providerId}`,
        {
          memberId: context.getters.user.memberId,
        },
      );
    },
  },
  mutations: {
    setProviders(state: ProvidersState, data: MemberProvidersResponseModel[]) {
      state.providers = data;
    },
  },
  getters: {
    providers(state): MemberProvidersResponseModel[] {
      return state.providers;
    },
    providersQuantity(state): number {
      return state.providers.length;
    },
  },
};

export default PROVIDERS_STATE;
